import {createRouter, createWebHistory} from "vue-router";
import personalRoute from "./modules/personal";
import previewRoutes from "./modules/preview";
import publicRoutes from "./modules/public";
import rootRoute from "./modules/root";

const routes = [
    ...publicRoutes,
    rootRoute,
    personalRoute,
    ...previewRoutes,
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
